import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import AvailableTranslationCacheName from "../../utils/AvailableTranslationCacheName";
import { acceptTranslationReview } from "../../api/acceptTranslationReview";

export function useAcceptTranslationReview(onSuccessCallback?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: acceptTranslationReview,
    onSuccess: () => {
      toast.success("Translation successfully approved");
      queryClient.invalidateQueries(AvailableTranslationCacheName.getAvailableTranslation());

      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
    onError: (error: AxiosError) => {
      const errorMessage = ErrorUtils.getErrorMessage(error);
      toast.error(errorMessage, {
        autoClose: false,
      });
    },
  });
}
